module.exports = __webpack_public_path__ + "img/h_features.08b8750f.svg";